/* eslint-disable @typescript-eslint/member-ordering */ export const releases = [
    {
        id: '24',
        version: '1.14.0',
        date: '2026-08-05',
        title: 'Histotime Plus（買い切り）',
        type: 'feature',
        summary: '一度の購入で広告の非表示とフォルダー・アーカイブの上限拡張がずっと使える「Histotime Plus」を追加しました。',
        sections: [
            {
                heading: '新機能',
                blocks: [
                    {
                        title: 'Histotime Plus（買い切り）',
                        bullets: [
                            {
                                text: '一度のご購入で、広告の非表示、フォルダー作成上限の拡張（15個 → 50個）、アーカイブ保存上限の拡張（30個 → 500個）がずっとご利用いただけます。設定画面からご確認ください。'
                            },
                            {
                                text: '機種変更後も「以前の購入を復元」から引き継げます。'
                            }
                        ]
                    }
                ]
            },
            {
                heading: 'お知らせ',
                blocks: [
                    {
                        title: '利用規約・プライバシーポリシーの改定',
                        bullets: [
                            {
                                text: 'アプリ内課金の提供開始にあわせて内容を見直しました。アップデート後の起動時に、改定内容のご確認と同意をお願いします。'
                            }
                        ]
                    }
                ]
            },
            {
                heading: '修正',
                blocks: [
                    {
                        bullets: [
                            {
                                text: 'フォルダーをアーカイブしても、新しいフォルダーを作成できないことがある問題を修正しました。'
                            },
                            {
                                text: 'ウィジェットのフォルダー選択に、アーカイブ済みのフォルダーが表示される問題を修正しました。'
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        id: '23',
        version: '1.13.1',
        date: '2026-07-19',
        title: '不具合の修正',
        type: 'bugfix',
        summary: 'アカウントに関する軽微な不具合を修正しました。',
        sections: [
            {
                heading: '修正',
                blocks: [
                    {
                        title: '不具合の修正',
                        bullets: [
                            {
                                text: 'アカウントに関する軽微な不具合を修正しました。'
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        id: '22',
        version: '1.13.0',
        date: '2026-07-14',
        title: 'Apple・Googleアカウント連携',
        type: 'feature',
        summary: 'AppleまたはGoogleアカウントでログインできるようになり、機種変更時も記録を引き継げるようになりました。',
        sections: [
            {
                heading: '新機能',
                blocks: [
                    {
                        title: 'Apple・Googleアカウント連携',
                        bullets: [
                            {
                                text: 'AppleまたはGoogleアカウントでログインできるようになりました。機種変更やアプリの再インストール時も、これまでの記録を引き継げます。'
                            }
                        ]
                    },
                    {
                        title: 'はじめての方向けの紹介画面',
                        bullets: [
                            {
                                text: '初回起動時に、Histotimeでできることを3画面でご案内するようになりました。'
                            }
                        ]
                    }
                ]
            },
            {
                heading: '改善点',
                blocks: [
                    {
                        title: 'アカウント削除画面',
                        bullets: [
                            {
                                text: '注意事項と手続きを1画面にまとめ、内容を確認してから削除できる流れにしました。'
                            }
                        ]
                    }
                ]
            },
            {
                heading: 'その他',
                blocks: [
                    {
                        bullets: [
                            {
                                text: 'パフォーマンスの改善を行いました。'
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        id: '21',
        version: '1.12.0',
        date: '2026-06-14',
        title: 'フォルダーアーカイブ機能',
        type: 'feature',
        summary: '使わなくなったフォルダーを削除せずに整理できるアーカイブ機能を追加しました。',
        sections: [
            {
                heading: '新機能',
                blocks: [
                    {
                        title: 'フォルダーアーカイブ',
                        bullets: [
                            {
                                text: '使わなくなったフォルダーを削除せずに整理できる機能を追加しました。アーカイブしたフォルダーは設定画面の「アーカイブ一覧」からいつでも閲覧でき、必要に応じて元に戻すこともできます。'
                            }
                        ]
                    }
                ]
            },
            {
                heading: '修正',
                blocks: [
                    {
                        title: '通知タイミングの不具合',
                        bullets: [
                            {
                                text: '記録を削除した直後など、意図しないタイミングで通知が表示される事象を修正しました。'
                            }
                        ]
                    }
                ]
            },
            {
                heading: 'その他',
                blocks: [
                    {
                        bullets: [
                            {
                                text: 'パフォーマンスの改善を行いました。'
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        id: '20',
        version: '1.11.0',
        date: '2026-05-21',
        title: 'アプリ内レビューとウィジェット改善',
        type: 'improvement',
        summary: 'アプリ内レビュー機能を追加し、カレンダーウィジェットの表示を改善しました。',
        sections: [
            {
                heading: '新機能',
                blocks: [
                    {
                        title: 'アプリ内レビュー',
                        bullets: [
                            {
                                text: '使い込んでいただいているユーザーの皆さまに、適切なタイミングでアプリの評価をお願いするダイアログが表示されるようになりました。'
                            }
                        ]
                    }
                ]
            },
            {
                heading: '改善点',
                blocks: [
                    {
                        title: 'カレンダーウィジェット',
                        bullets: [
                            {
                                text: '今日の記録一覧で最新の記録が表示されない問題を修正し、あわせて表示できる件数を増やしました。'
                            }
                        ]
                    }
                ]
            },
            {
                heading: 'その他',
                blocks: [
                    {
                        bullets: [
                            {
                                text: 'パフォーマンスの改善を行いました。'
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        id: '19',
        version: '1.10.1',
        date: '2026-04-06',
        title: '通知タップ時の画面遷移を修正',
        type: 'bugfix',
        summary: '通知をタップしたときに正しく記録画面が開くように修正しました。',
        sections: [
            {
                heading: '不具合修正',
                blocks: [
                    {
                        text: '通知タップ時の画面遷移を修正しました。アプリを閉じている状態や、ホーム画面以外を開いている状態でも、正しく記録画面が開くようになりました。'
                    }
                ]
            }
        ]
    },
    {
        id: '18',
        version: '1.10.0',
        date: '2026-04-02',
        title: 'ホーム画面ウィジェット',
        type: 'feature',
        summary: 'アプリを開かずに記録状況を確認できるホーム画面ウィジェットを4種類追加しました。',
        sections: [
            {
                heading: '新機能',
                blocks: [
                    {
                        title: 'ホーム画面ウィジェット',
                        bullets: [
                            {
                                text: 'ホーム画面にフォルダーを配置して、アプリを開かずに記録状況を確認できます。タップするとアプリの該当フォルダーに直接移動します。'
                            }
                        ]
                    },
                    {
                        title: '4種類のウィジェット',
                        bullets: [
                            {
                                text: 'フォルダー一覧：お気に入りのフォルダーをグリッド表示'
                            },
                            {
                                text: 'カレンダー：今月の記録状況と今日の記録をひと目で確認'
                            },
                            {
                                text: '記録グラフ：記録した日をカレンダー形式でマーク表示'
                            },
                            {
                                text: 'ロック画面：ロック画面からフォルダーにすぐアクセス'
                            }
                        ]
                    },
                    {
                        text: 'ウィジェットをタップすると、アプリの該当フォルダーに直接移動できます。'
                    }
                ]
            }
        ]
    },
    {
        id: '17',
        version: '1.9.0',
        date: '2026-02-02',
        title: 'プッシュ通知機能',
        type: 'feature',
        summary: '設定した間隔でお知らせするプッシュ通知と、フォルダーごとの通知間隔モードを追加しました。',
        sections: [
            {
                heading: '新機能',
                blocks: [
                    {
                        title: 'プッシュ通知',
                        bullets: [
                            {
                                text: '設定した間隔に基づいて通知でお知らせします。通知から「今すぐ記録」ボタンをタップすると、素早く時間を記録できます。'
                            }
                        ]
                    },
                    {
                        title: '通知間隔モード',
                        bullets: [
                            {
                                text: 'フォルダーごとに2つのモードから選択できます。',
                                subItems: [
                                    'やり過ぎ防止モード：設定した時間が経過するまで待つべきタスク向け',
                                    '忘れ防止モード：設定した時間以内に実行すべきタスク向け'
                                ]
                            }
                        ]
                    },
                    {
                        title: 'ステータスアイコン',
                        bullets: [
                            {
                                text: 'ホーム画面でフォルダーの状態が一目でわかるアイコンを追加しました。ヘルプボタンからアイコンの意味を確認できます。'
                            }
                        ]
                    }
                ]
            },
            {
                heading: '改善点',
                blocks: [
                    {
                        bullets: [
                            {
                                text: '各画面のデザインを改善しました。'
                            },
                            {
                                text: 'パフォーマンスと安定性の向上'
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        id: '16',
        version: '1.8.0',
        date: '2026-01-18',
        title: '経過時間表示機能',
        type: 'feature',
        summary: 'ホーム画面で各フォルダーの最終記録からの経過時間が一目で確認できるようになりました。',
        details: [
            'フォルダーごとの経過時間をホーム画面に表示'
        ]
    },
    {
        id: '15',
        version: '1.7.0',
        date: '2025-12-15',
        title: 'フォルダー拡張機能',
        type: 'feature',
        summary: '広告視聴でフォルダーを拡張できるようになりました。既存ユーザーは15個のフォルダーをすべて利用可能です。',
        details: [
            '広告視聴によるフォルダー拡張機能を実装'
        ]
    },
    {
        id: '14',
        version: '1.6.0',
        date: '2025-11-16',
        title: 'カレンダー機能',
        type: 'feature',
        summary: 'カレンダー機能を追加して、フォルダーごとの記録を見やすくしました。',
        details: [
            'カレンダー上にその日記録したフォルダーのラベルカラーを表示',
            'その日に記録した全てのフォルダーを時系列で一覧表示'
        ]
    },
    {
        id: '13',
        version: '1.5.0',
        date: '2025-04-15',
        title: 'バグ修正とパフォーマンス改善',
        type: 'improvement',
        summary: 'アプリの安定性とパフォーマンスを改善しました。',
        details: [
            'バグ修正',
            'パフォーマンス改善'
        ]
    },
    {
        id: '12',
        version: '1.4.1',
        date: '2025-04-08',
        title: '不具合の修正',
        type: 'bugfix',
        summary: '軽微な不具合を修正しました。',
        details: [
            '不具合の修正'
        ]
    },
    {
        id: '11',
        version: '1.4.0',
        date: '2025-04-03',
        title: 'ラベルカラー編集機能',
        type: 'feature',
        summary: 'フォルダーのラベルカラーを編集できるようになりました。',
        details: [
            'フォルダーのラベルカラー編集機能を追加'
        ]
    },
    {
        id: '10',
        version: '1.3.1',
        date: '2024-12-31',
        title: '不具合の修正',
        type: 'bugfix',
        summary: '軽微な不具合を修正しました。',
        details: [
            '不具合の修正'
        ]
    },
    {
        id: '9',
        version: '1.3.0',
        date: '2024-12-29',
        title: '不具合修正と機能改善',
        type: 'improvement',
        summary: '不具合修正と一部機能を改善しました。',
        details: [
            '不具合修正',
            '一部機能改善'
        ]
    },
    {
        id: '8',
        version: '1.2.2',
        date: '2024-10-24',
        title: 'バグ修正',
        type: 'bugfix',
        summary: 'バグを修正しました。',
        details: [
            'バグ修正'
        ]
    },
    {
        id: '7',
        version: '1.2.1',
        date: '2024-10-23',
        title: 'バグ修正',
        type: 'bugfix',
        summary: 'バグを修正しました。',
        details: [
            'バグ修正'
        ]
    },
    {
        id: '6',
        version: '1.2.0',
        date: '2024-10-21',
        title: '時間編集機能',
        type: 'feature',
        summary: '記録した時間を後から編集できるようになりました。',
        details: [
            '記録時間の編集機能を追加'
        ]
    },
    {
        id: '5',
        version: '1.1.1',
        date: '2024-10-16',
        title: 'UI改善',
        type: 'improvement',
        summary: 'ユーザーインターフェースを改善しました。',
        details: [
            'UI改善'
        ]
    },
    {
        id: '4',
        version: '1.1.0',
        date: '2024-10-15',
        title: 'お問い合わせフォーム追加',
        type: 'feature',
        summary: 'アプリ内からお問い合わせができるようになりました。',
        details: [
            '不具合修正',
            'お問い合わせフォームを追加'
        ]
    },
    {
        id: '3',
        version: '1.0.2',
        date: '2024-10-03',
        title: 'スプラッシュ画面修正',
        type: 'bugfix',
        summary: 'スプラッシュ画面を修正し、設定画面にバージョン情報を追加しました。',
        details: [
            'スプラッシュ画面修正',
            '設定画面にバージョン情報追加'
        ]
    },
    {
        id: '2',
        version: '1.0.1',
        date: '2024-10-02',
        title: 'UI改善',
        type: 'bugfix',
        summary: 'ユーザーインターフェースを改善しました。',
        details: [
            'UI改善'
        ]
    },
    {
        id: '1',
        version: '1.0.0',
        date: '2024-10-02',
        title: '正式リリース',
        type: 'feature',
        summary: 'Histotimeの正式版をリリースしました。',
        details: [
            'ワンタップで行動を記録',
            '履歴一覧で過去の記録を確認'
        ]
    }
];
